module.exports = __webpack_public_path__ + "img/flower-top.cbd20f9f.png";